module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid45_960x837.a212acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid45_960x837.jpg
// module id = d20f
// module chunks = 0